module.exports = __webpack_public_path__ + "img/newchris-30.653131ad.jpg";